/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/*
function sampleData(){
    var samples = sessionStorage.getItem('samples');
    if(samples){
        var data = samples.split(',');
      for(i=0;i<data.length;i++){
        //console.log(data[i]);
          $("[data-sku='" + data[i] + "']").attr('disabled', true).text('Sample Added');
      }
    }
  }
function checkCartSmples(){
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart){
        //console.log(cart);
        var samples = 0;
        var samplesData = [];
        if(cart.items.length){
          for (i=0;i<cart.items.length;i++){
          	var id = cart.items[i].id;
            if (id == 43089714249963){
              samples++;
              samplesData.push(cart.items[i].properties.SKU);
            }
          }
        }
        sessionStorage.setItem('samples', samplesData.join(','));
        sampleData();
        if (samples >= 5){
        	$('.product-get-sample').attr('disabled', true);
        }else{
        	//console.log(samples);
        }
        
      }
    });
}

checkCartSmples();

$('body').on('click','.product-get-sample',function(){
    var sampleBtn = $(this);
	var name = sampleBtn.data('name');
    var sku = sampleBtn.data('sku');
    var sample = sampleBtn.data('sample');
    
    sampleBtn.addClass('in');
  
	$.ajax({
      type: 'post',
      url: '/cart/add.js',
      data: {
        items: [
          {
            quantity: 1,
            id: sample,
            properties: {
              'Product': name,
              'SKU': sku
            }
          }
        ]
      },
      success: function(cart){
        //console.log(cart.items);
        if (cart.items[0].quantity >1){
          jQuery.post('/cart/change.js', { id: sample, line: 1 });
        }
        sampleBtn.removeClass('in').attr('disabled', true).text('Sample Added');
        checkCartSmples();
      },
      dataType: 'json'
    });
  	
});
*/

$(document).ready(function () {
  if ($('.filter-checkbox').length) {
    $('.filter-checkbox').on('change', function () {
      $(this).closest('form').submit();
    });
  }
  if ($('.tag-filter').length) {
    var collQuery = window.location.search;
    $('.tag-filter').each(function () {
      $(this).attr('href', $(this).attr('href') + collQuery);
    });
  }
  if ($('.active-filters .tag-filter').length) {
    var collQuery = window.location.search;
    $('.active-filters .tag-filter').each(function () {
      $(this).attr('href', $(this).attr('href') + collQuery);
    });
  }
});
document.querySelectorAll("a[href=\"#open-chat\"]").forEach(function (link) {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click();
  });
});
/******/ })()
;